import './Exam_chartDetailTec.scss';
import * as S from '../scss/theme';
import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import fnc from '../mymod/commFunction';
import Button from '@mui/material/Button';
import HeaderTitle from "../comm/HeaderTitle";
import Exam_ChartSt from './Exam_ChartSt';
import Exam_chartDetail from './Exam_chartDetail';
import imgReport from '../images/svg/report.svg';

import { useDispatch, useSelector } from 'react-redux';
import { setList_pdf, setRowIdx_pdf, setKind, setList_pdf_marking, setList_pdf_complete, 
          setSelectedPage_pdf, setHeaderInfo, setSelectedBookDetailCode, setIsBookStudy } from '../reduxToolkit/redux';


const Exam_chartDetailTec = ({testCode, setIsModalTec}) => {//selectedItem이건 bookCode: 1345임 value: 1345가 아니고
    const location = useLocation();
    const imgUrl = process.env.REACT_APP_imgUrl;
    const dispatch = useDispatch();

    const selectedUnit_pdf = useSelector(state => state.reduxStore.selectedUnit_pdf);
    const isRefresh_bookMain = useSelector(state => state.reduxStore.isRefresh_bookMain);
    const userKind = useSelector(state => state.reduxStore.userInfo.kind);
    const selectedBookDetailCode = useSelector(state => state.reduxStore.selectedBookDetailCode);
    const isBookStudy = useSelector(state => state.reduxStore.isBookStudy);
    
    const [list, setList] = useState([]);
    const [isModal, setIsModal] = useState(false);
    const [isModal_memo, setIsModal_memo] = useState(false);
    const [isModal_marking, setIsModal_marking] = useState(false);
    const [isModal_complete, setIsModal_complete] = useState(false);
    // const [selectedListItem, setSelectedListItem] = useState({}); 
    const [selectedItems, setSelectedItems] = useState([]);//체크박스
    const [selectAll, setSelectAll] = useState(false);//체크박스

    const [title, setTitle] = useState("");
    const [isModal_chart, setIsModal_chart] = useState(false);
    const [stCode, setStCode] = useState(null);


    useEffect(() => {
      fncSelectList();

    }, [testCode]);

    
  
  function fncSelectList() {
    const acaCode = fnc.getCookie('acaCode');
    const stCode = fnc.getCookie('stCode');
    // const testCode = selectedListItem.testCode;

    fnc.sendAxios('/select/exam/report/detailTec', {testCode }, (res) => {
      if (res && Array.isArray(res)) { //단원선택 클릭 시 결과 (오른쪽 페이지 list)
    
        const newList = getRecords_list(res);
        setList(newList);

      } else {
        console.log(res,"kuesbChartDetailRoutes/select/book/pdfList");
      }
    });
  }
  
  function getRecords_list(res) {
    let records = [];
    for (let i = 0; i < res.length; i++) {      
        const sno= res[i]["sno"];
        const testCodeMun = res[i]["testCodeMun"];
        const testNm = res[i]["testNm"];
        const munCnt = res[i]["munCnt"];
        const stNm = res[i]["stNm"];
        const stCode = res[i]["stCode"];
        let hp = res[i]["hp"];
        hp=fnc.formatPhoneNumber(hp);
        let score = res[i]["score"];
        score = score.toFixed(1);
        const Xcnt = res[i]["xCnt"];
        const Ocnt = res[i]["oCnt"];
        const oxBar = res[i]["oxBar"];
        const markingBar = res[i]["markingBar"];
        const dapBar = res[i]["dapBar"];
        const sDate = res[i]["sDate"];
        let avg = res[i]["avg"];
        avg = avg.toFixed(1);
        const rank = res[i]["rank"];
        const correctRate = Ocnt + Xcnt > 0 ? (Ocnt / (Ocnt + Xcnt)) * 100 : 0;

        records.push({ sno, testCodeMun, testNm, munCnt, stNm, stCode, hp,
          score, Ocnt, Xcnt, oxBar, markingBar, dapBar, correctRate: score, sDate, avg, rank });
    }
    return records;
  }


 

    //=========================================
    return (
      //자식 컨포넌트
      <div className="Exam_chartDetailTec">
         <HeaderTitle  title={title} direction={1} onBackClick={() => setIsModalTec(false)} />
         <Button className='btnClose-me' onClick={() => setIsModalTec(false)} >
            <i class="fa-solid fa-xmark"></i>
        </Button> 

        <div className="wrap-book-main">
          <section className="section-book-main">
            <table className="table-hong table-chartDetailTec">
              <thead>
                <tr>
                  <th>no</th>      
                  <th>성명</th>
                  {/* <th>휴대전화</th> */}
                  <th>문항수</th>
                  <th>맞음(개)</th>
                  <th>틀림(개)</th>
                  <th>점수</th>
                  <th>평균</th>
                  <th>석차</th>
                  <th>제출일</th>
                  <th>상세</th>
              
                </tr>
              </thead>

              <tbody>

               { list.map((item, index) =>  {

                  return(
                      <tr key={item.sno}>
                        <td>{index + 1}</td>                 
                        <td>{item.stNm} <br />{item.hp}</td>
                        {/* <td>{item.hp}</td> */}
                        <td>{item.munCnt}</td>
                        <td>{item.Ocnt}</td>
                        <td>{item.Xcnt}</td>
                        <td>{item.correctRate}</td>
                        <td>{item.avg}</td>
                        <td>{item.rank}</td>
                        <td>{item.sDate}</td>
                        <td>
                            <Button className="btnReport"
                                onClick={() => onChartSt(item)}
                                startIcon={<img src={imgReport} alt="Report" />}>
                            </Button>
                        </td>


                        
                      </tr>
                  );

                })}
                
              </tbody>

            </table>
          </section>

        </div>

        {isModal_chart && (
                <S.Modal>
                     <HeaderTitle  title={title} direction={1} onBackClick={() => setIsModal_chart(false)} />
                    <div style={{display:'flex', flexDirection:'row', gap: '1rem'}}>
                      
                        <section className="section-chart-detail">
                            <Exam_chartDetail testCode={testCode} stCode={stCode} />
                        </section>

                        <section className="section-chart">
                            <Exam_ChartSt testCode={testCode} stCode={stCode} setIsModal={setIsModal_chart} />
                        </section>

                        </div>
                    
                </S.Modal>
            )}
     
      </div>
    );

    //===============================================================
    function onChartSt(item) {

      setStCode(item.stCode);
      setIsModal_chart(true);
    }
}

export default Exam_chartDetailTec;
